import { render } from "./ClientSelect.vue?vue&type=template&id=5659f708&scoped=true"
import script from "./ClientSelect.vue?vue&type=script&lang=js"
export * from "./ClientSelect.vue?vue&type=script&lang=js"

import "./ClientSelect.vue?vue&type=style&index=0&id=5659f708&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5659f708"]])

export default __exports__